import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// ======================================
// STYLES
// ======================================
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
  },

  header: {
    borderBottom: "2 solid #0f172a",
    marginBottom: 15,
    paddingBottom: 10,
  },

  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#E11D48",
  },

  subtitle: {
    fontSize: 10,
    color: "#555",
  },

  image: {
    width: 120,
    height: 100,
    objectFit: "cover",
    border: "1 solid #ccc",
    marginBottom: 10,
  },

  row: {
    flexDirection: "row",
    borderBottom: "1 solid #eee",
    padding: 6,
  },

  head: {
    backgroundColor: "#111827",
    color: "#fff",
    fontWeight: "bold",
  },

  col: {
    flex: 1,
  },

  totalBox: {
    marginTop: 15,
    padding: 10,
    border: "1 solid #111827",
  },

  green: { color: "#16A34A" },
  red: { color: "#DC2626" },
});

// ======================================
// PDF COMPONENT
// ======================================
const PaymentHistoryPDF = ({ shipment }) => {
  if (!shipment) return null;

  const API_BASE_URL =
    process.env.REACT_APP_API_URL ||
    "https://zuluwhiskeyshipping.online";

  const goodsImageUrl = shipment.goods_image
    ? shipment.goods_image.startsWith("http")
      ? shipment.goods_image
      : `${API_BASE_URL}${shipment.goods_image}`
    : null;

  const payments = shipment.payments || [];

  const totalPaid = Number(shipment.amount_paid || 0);

  const charge =
    Number(shipment.amount_charge || 0) -
    Number(shipment.discount || 0);

  return (
    <Document>
      <Page style={styles.page}>
        {/* HEADER */}
        <View style={styles.header}>
          <Text style={styles.title}>Zuluwhiskey Shipping</Text>

          <Text style={styles.subtitle}>
            Payment History Report
          </Text>

          <Text style={styles.subtitle}>
            Customer: {shipment.customer_name}
          </Text>

          <Text style={styles.subtitle}>
            Tracking: {shipment.tracking_code}
          </Text>
        </View>

        {/* IMAGE */}
        {goodsImageUrl && (
          <Image src={goodsImageUrl} style={styles.image} />
        )}

        {/* SUMMARY */}
        <View style={styles.totalBox}>
          <Text>
            Total Charge: ${charge.toFixed(2)}
          </Text>

          <Text style={styles.green}>
            Total Paid: ${totalPaid.toFixed(2)}
          </Text>

          <Text style={styles.red}>
            Balance: ${(charge - totalPaid).toFixed(2)}
          </Text>
        </View>

        {/* TABLE HEADER */}
        <View style={[styles.row, styles.head]}>
          <Text style={styles.col}>Date</Text>
          <Text style={styles.col}>Payment Region</Text>
          <Text style={styles.col}>Amount</Text>
        </View>

        {/* PAYMENTS */}
        {payments.map((p, i) => (
          <View style={styles.row} key={i}>
            <Text style={styles.col}>
              {new Date(p.created_at).toLocaleString()}
            </Text>

            <Text style={styles.col}>
              {p.payment_type === "us" ? "USA" : "Liberia"}
            </Text>

            <Text style={styles.col}>
              ${Number(p.amount).toFixed(2)}
            </Text>
          </View>
        ))}

        {/* SIGNATURE */}
        <View style={{ marginTop: 40, alignItems: "flex-end" }}>
          <Text style={{ fontSize: 10, marginBottom: 30 }}>
            ________________________________
          </Text>

          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            Management Signature
          </Text>

          <Text style={{ fontSize: 9, color: "#555" }}>
            Zuluwhiskey Shipping Management
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PaymentHistoryPDF;


// // PaymentHistoryPDF.js

// import React from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";

// const styles = StyleSheet.create({
//   page: {
//     padding: 30,
//     fontSize: 10,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff",
//   },

//   header: {
//     borderBottom: "2 solid #0f172a",
//     marginBottom: 15,
//     paddingBottom: 10,
//   },

//   title: {
//     fontSize: 18,
//     fontWeight: "bold",
//     color: "#E11D48",
//   },

//   subtitle: {
//     fontSize: 10,
//     color: "#555",
//   },

//   sectionTitle: {
//     marginTop: 15,
//     fontSize: 12,
//     fontWeight: "bold",
//     color: "#111827",
//     marginBottom: 8,
//   },

//   image: {
//     width: 120,
//     height: 100,
//     objectFit: "cover",
//     border: "1 solid #ccc",
//     marginBottom: 10,
//   },

//   table: {
//     marginTop: 10,
//     border: "1 solid #ddd",
//   },

//   row: {
//     flexDirection: "row",
//     borderBottom: "1 solid #eee",
//     padding: 6,
//   },

//   head: {
//     backgroundColor: "#111827",
//     color: "#fff",
//     fontWeight: "bold",
//   },

//   col: {
//     flex: 1,
//   },

//   totalBox: {
//     marginTop: 15,
//     padding: 10,
//     border: "1 solid #111827",
//   },

//   totalText: {
//     fontWeight: "bold",
//   },

//   red: {
//     color: "#DC2626",
//   },

//   green: {
//     color: "#16A34A",
//   },
// });

// const PaymentHistoryPDF = ({ shipment }) => {
//   if (!shipment) return null;

//   const API_BASE_URL =
//     process.env.REACT_APP_API_URL ||
//     "https://zuluwhiskeyshipping.online";

//   const goodsImageUrl = shipment.goods_image
//     ? shipment.goods_image.startsWith("http")
//       ? shipment.goods_image
//       : `${API_BASE_URL}${shipment.goods_image}`
//     : null;

//   console.log("PDF Image URL:", goodsImageUrl);

//   const payments = shipment.payments || [];

//   const totalPaid = Number(
//     shipment.amount_paid || 0
//   );

//   const charge =
//     Number(shipment.amount_charge || 0) -
//     Number(shipment.discount || 0);

//   return (
//     <Document>
//       <Page style={styles.page}>

//         {/* HEADER */}
//         <View style={styles.header}>
//           <Text style={styles.title}>
//             Zuluwhiskey Shipping
//           </Text>

//           <Text style={styles.subtitle}>
//             Payment History Report
//           </Text>

//           <Text style={styles.subtitle}>
//             Customer: {shipment.customer_name}
//           </Text>

//           <Text style={styles.subtitle}>
//             Tracking: {shipment.tracking_code}
//           </Text>
//         </View>

//         {/* GOODS IMAGE */}
//         {goodsImageUrl && (
//           <Image
//             src={goodsImageUrl}
//             style={styles.image}
//           />
//         )}

//         {/* SUMMARY */}
//         <View style={styles.totalBox}>
//           <Text style={styles.totalText}>
//             Total Charge: $
//             {charge.toFixed(2)}
//           </Text>

//           <Text style={styles.green}>
//             Total Paid: $
//             {totalPaid.toFixed(2)}
//           </Text>

//           <Text style={styles.red}>
//             Balance: $
//             {(charge - totalPaid).toFixed(2)}
//           </Text>
//         </View>

//         {/* TABLE HEADER */}
//         <View style={[styles.row, styles.head]}>
//           <Text style={styles.col}>
//             Date
//           </Text>

//           <Text style={styles.col}>
//             Payment Region
//           </Text>

//           <Text style={styles.col}>
//             Amount
//           </Text>
//         </View>

//         {/* PAYMENTS */}
//         {payments.map((p, i) => (
//           <View
//             style={styles.row}
//             key={i}
//           >
//             <Text style={styles.col}>
//               {new Date(
//                 p.created_at
//               ).toLocaleString()}
//             </Text>

//             <Text style={styles.col}>
//               {p.payment_type === "us"
//                 ? "USA"
//                 : "Liberia"}
//             </Text>

//             <Text style={styles.col}>
//               $
//               {Number(
//                 p.amount
//               ).toFixed(2)}
//             </Text>
//           </View>
//         ))}

//         {/* SIGNATURE */}
//         <View
//           style={{
//             marginTop: 40,
//             alignItems: "flex-end",
//           }}
//         >
//           <Text
//             style={{
//               fontSize: 10,
//               marginBottom: 30,
//             }}
//           >
//             ________________________________
//           </Text>

//           <Text
//             style={{
//               fontSize: 10,
//               fontWeight: "bold",
//             }}
//           >
//             Management Signature
//           </Text>

//           <Text
//             style={{
//               fontSize: 9,
//               color: "#555",
//             }}
//           >
//             Zuluwhiskey Shipping Management
//           </Text>
//         </View>

//       </Page>
//     </Document>
//   );
// };

// export default PaymentHistoryPDF;

